// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1YmFt","image":"Header_image__bnH71","name":"Header_name__3h6KO","info":"Header_info__NtF8X","infoRow":"Header_infoRow__plVzV"};